import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import React from 'react';
import { useHistory } from "react-router-dom";
import Page from "../../containers/Page/Page";
import { useLoading } from "../../hooks/loading";
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface ICliente {
    id: string;
    nome: string;
}

function Descontos() {

    //Hooks
    const history = useHistory();

    //Loading
    const { startLoading, stopLoading, isLoading } = useLoading();

    //States
    const [error, setError] = React.useState<string>('');
    const [clientes, setClientes] = React.useState<ICliente[]>([]);

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar clientes.
     */
    async function handleFetch() {
        startLoading('main');
        try {
            const response = await api.get('propostas/create');
            setClientes(response.data.object.clientes);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        } finally {
            stopLoading('main');
        }
    }

    return (
        <Page error={error} loading={isLoading('main')}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Descontos / Clientes
                </Typography>
            </Page.Title>
            {clientes &&
                <Page.Section>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Cliente</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {clientes.map((cliente) => (
                                        <TableRow
                                            key={cliente.id}
                                            hover={true}
                                            onClick={() => history.push(`/descontos/cliente/${cliente.id}`)}
                                        >
                                            <TableCell>{cliente.nome}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Descontos;